"use client";

import { createContext, useContext } from "react";
import type { BrandConfig } from "@/config/brands";

const BrandContext = createContext<BrandConfig | null>(null);

export function BrandProvider({
  brand,
  children,
}: {
  brand: BrandConfig;
  children: React.ReactNode;
}) {
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

/** Marca atual no client. Deve estar dentro de <BrandProvider>. */
export function useBrand(): BrandConfig {
  const brand = useContext(BrandContext);
  if (!brand) {
    throw new Error("useBrand deve ser usado dentro de <BrandProvider>");
  }
  return brand;
}
